export const myListTimeSeriess = /* GraphQL */ `
  query MyListTimeSeriess(
    $symbol: String
    $frequency: ModelStringKeyConditionInput
    $filter: ModelTimeSeriesFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listTimeSeriess(
      symbol: $symbol
      frequency: $frequency
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        symbol
        frequency
        csvFile
        updatedAt
      }
      nextToken
    }
  }
`;

export const myListSciHackFiles = /* GraphQL */ `
  query MyListSciHackFiles(
    $userName: String
    $fileName: ModelStringKeyConditionInput
    $filter: ModelSciHackFileFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSciHackFiles(
      userName: $userName
      fileName: $fileName
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        description
        fileType
        fileName
        updatedAt
      }
      nextToken
    }
  }
`;
